import Tooltip from './styled';

export default Tooltip;
